module.exports = __webpack_public_path__ + "9061a73b6368951d11fd9973ec281432.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/integral_logo.svg
// module id = 1660
// module chunks = 1